export default {
  'home': 'home',
  course: '课程',
  live: '直播',
  short_video: "短视频",
  public_exam: '公开考试',
  training_class: '面授班',
  infor_list: '资讯',
  Knowledge_lib: '文库',
  intelligent_circle: '知圈',
  learning_footprint: '学习足迹',
  my_course: '我的课程',
  my_exam: '我的考试',
  learn_map: '学习地图',
  zhi_niao: 'e祺学',
  exam: '考试',
  EBOOK: '电子书',
  i_want_public:'我要发帖',
  questionnaire: '问卷',
  new_questionnaire: "新问卷",
  my_training_class: '我的面授班',
  my_questionnaire: '我的问卷',
  practice_train: '实践培训',
  my_homework: '我的作业',
  training_project: '培训项目',
  learn_tasks: '学习任务',
  more:'查看更多',
  error: '请求出错',
  fail: '请求失败',
  confirm: '确定',
  confirm_empty:'确 定',
  cancel: '取消',
  check: '查看',
  practice: '实操',
  stage_learn_project: "阶段学习项目",
  nonsupport: 'e祺学网页版暂不支持查看该资源，敬请期待！',
  no_support_vs:'暂不支持查看该资源，敬请期待！',
  intelligent_portal: '智门户暂不支持进入我的面授班，请使用e祺学App',
  playback: '回放',
  back: '返回',
  commend: '推荐',
  exam_score: '考试成绩',
  ten_thousand: '万',
  learned: '已学',
  no_learned: '未学',
  has_learned: '已学习',
  is_passed: "已通过",
  fail_passed: '不通过',
  not_passed: '未通过',
  to_be_approved: '待通过',
  score: '分',
  no_score: '暂无评分',
  Intelligent_accompaniment: "智能陪练",
  conmment_score: '评分：',
  submit__score: "提交评分",
  all: '全部',
  i_got_it: "我知道了",
  book_tip: '该课件类型为电子书，目前暂时只支持在e祺学APP上学习。请通过e祺学APP学习该课件。',
  no_permission: '抱歉，您没有查看此课程的权限',
  go_training_programs: '该资源属于培训项目内容，为了学习数据的有效性，请前往对应的培训项目学习！',
  need_accept_oversight: '抱歉！学习该课程需要接收监管，只在app上进行学习。',
  go_app_learn: '为保证学习数据有效性，请使用e祺学APP学习。',
  video_learn: '该课程需要视频监学，必须通过e祺学APP进行学习。请打开e祺学APP学习该课程。',
  need_sign: '该课程需要签名，必须通过e祺学APP进行学习签名。请打开e祺学APP学习该课程。',
  lift_lockdown: '已达到截屏最大次数，禁止再次进入课程，请联系管理员解封',
  punch_in_completed: '完成打卡验证',
  please_punch_in_completed: '请完成打卡验证',
  verify_complete: '验证完成',
  Initializing: '初始化中...',
  intelligent_detection: '智能检测中...',
  click_complete_verification: '点击完成验证',
  second: '秒',
  enter_verification_code: "请输入验证码",
  captcha_error: '验证码错误',
  verification_code: '验证码',
  submit_success: '提交成功',
  author: '作者',
  producer: '制作人',
  brief_introduction: '简介：',
  pack_up_detail: '收起详细介绍',
  spread_details: '展开详细介绍',
  all_comments: '全部评论',
  headline_Review: '头条评论',
  latest_comments: '最新评论',
  no_comments: '还没有人发表评论',
  publish_Comment: "发表评论",
  no_more_comments: "没有更多评论了",
  see_more_comments: "查看更多评论",
  submit_comment_tip: '写够5个字才能提交哦，么么哒',
  disabled_drag: '本课程设置为禁止拖动',
  tip_screen: '请始终保持课程窗口最大化，否则无法开始学习',
  goto_complete: '请先完成课程的学习',
  network_anomaly: '网络异常',
  abnormal: '异常',
  no_data: '暂无数据',
  login_password: "请输入登录密码",
  enter_password: '请输入密码',
  enter_password_again: '密码错误，请重新输入',
  enter_password_info: "请输入登录密码以校验身份",
  next_txt: '下一步',
  not_started: '未开始',
  ongoing: '进行中',
  Living: '直播中',
  is_over: '已结束',
  playing_back: '回放中',
  invalid_live: '无效直播',
  living: '正在直播',
  finished: '已完成',
  no_finished: '未完成',
  returned: '被退回',
  training_time: '培训时间',
  format_time_year: 'YYYY年MM月DD日',
  format_time_mouth: 'MM月DD日',
  this_time_score: "本次成绩得分",
  affirm_submit: '是否确认提交',
  upload_file: '上传文件',
  files: '文件',
  title_name: "名称",
  typeof: '类型',
  support: "赞",
  like_num: '点赞数',
  clock_support: "点赞",
  select_more: '查看全部',
  unread: '未读',
  my_news: '我的消息',
  my_setting: '我的设置',
  user_center: "个人中心",
  my_circle: '我的知圈',
  no_nickName: '暂无昵称',
  no_content: "还没有内容",
  delete: '删除',
  go_face_class: '立即前往该面授班吗？',
  go_exam: '立即前往该考试开始答题吗？',
  go_live: '立即前往该直播吗？',
  go_learn_map: '立即前往该学习地图吗？',
  go_intelligent_circle: '立即前往该帖子吗？',
  web_cannot_open: "网页无法打开此类消息",
  use_zhiniao_app: '请使用e祺学app阅读此消息',
  intelligent_portal_home: '01Web-智门户首页',
  opening_time: '开课时间',
  day: '天',
  hours: '时',
  minutes: '分',
  seconds: '秒',
  no_limits: '不限',
  live_time: '直播时间',
  cut_off_time: '截止时间：',
  training_matters: "培训事项",
  face_class_Introduction: '面授班介绍',
  schedule: '日程表',
  honor_rank: '荣誉榜',
  discuss: '讨论区',
  homeWork: '作业',
  certificate_completion: '结业证书',
  head_master: '班主任',
  head_master_colon: '班主任： ',
  training_matters1309: '1309Web-查看培训事项',
  check_training_Intro1310: '1310Web-查看培训介绍',
  check_schedule1304: '1304Web-查看日程表',
  check_rank1306: '1306Web-查看荣誉榜',
  go_discuss1307: '1307Web-进入讨论区',
  show_training_detail1301: '1301Web-显示培训班详情',
  trainclass13: '13Web-培训班',
  web_learn_task04: '04Web-学习任务',
  logout: "退出登录",
  circle: '圈子',
  search_circle: '搜索圈子',
  all_circle: '全部圈子',
  concel_empty: "取 消",
  confirm_txt: "确 定",
  copy_success: '复制成功',
  copy_failed: "复制失败",
  insert_picture: '插入图片',
  input_text: '请输入正文内容',
  search_name_number: "搜索姓名/员工编号",
  not_found_search: "未找到搜索项",
  enclosure_title: '附件名称',
  url: '链接',
  operation: '操作',
  posted: '发帖',
  my_post: '我的发帖',
  undercarriage: '下架',
  setting_success: '设置成功',
  setting_failed: '设置失败',
  undercarriage_success: "下架成功",
  undercarriage_failed: "下架失败",
  one_minutes_ago: '1分钟前',
  much_minutes_ago: '{time}分钟前',
  much_hours_ago: '{hourGap}小时前',
  min_length_limit: '写够{minLength}字才能提交哦',
  cancel_topping: '取消置顶',
  set_topping: '设为置顶',
  cancel_essence: '取消精华',
  set_essence: '设为精华',
  practical_training: "实践培训",
  filled_in: "已填写",
  no_filled_in: "待填写",
  not_open: "未开放",
  summary_newcomers: "新人每周总结",
  training_time_colon: "培训时间:",
  unopened: '未开启',
  daily_summary_newcomers: "新人每日总结",
  mentor_name: '指导人名称:',
  interview_track_record: '面谈跟踪记录表',
  evaluated: '已评价',
  to_be_evaluated: '待评价',
  reviewed: '已审阅',
  to_be_reviewed: '待审阅',
  formal_exam: '正式考试',
  mock_exam: '模拟考试',
  test_num: '共{testNum}题',
  total_score: '满分',
  not_yet: '还没有',
  anchor: '主播：',
  total_pics: "共{smallImgList}张图片",
  collection: '收藏',
  cover_map: '封面图',
  enterprise_course: '企业课',
  no_resources_found: '没有搜索到资源',
  learn_map11: '11Web-学习地图',
  my_learn_map: "我的学习地图",
  not_learning: "未学习",
  other: '其它',
  posts_count: '帖子数：',
  follow_count: '关注数：',
  followed: '已关注',
  follow: '关注',
  concel_follow: '已取消关注',
  follow_success: '关注成功',
  confirm_concel_follow: '确定取消关注吗？',
  Background_process_error: '后台处理错误',
  anchor_top_list: "圈主排行榜",
  rank: '排行榜',
  Recent_classes: '最近开班',
  most_popular: '最热门',
  registration_time: '报名时间',
  reported_limit: '已报限报',
  no_training_class: '还没有面授班',
  validation_failed: '验证失败',
  course_list07: "07Web-课程详情页",
  limit_value_tip: '感谢您认真学习，您学习已超过{limitValue}小时，为保障学习质量，请您休息，明天再学习吧！',
  scored: '已评分',
  mark_score: '我要评分',
  learn_order: '该培训项目需要严格按照顺序学习',
  go_continue: '请继续学习以下资源',
  click_catalog0703: '0703Web-点击目录项',
  give_mark0706: '0706Web-参与评分',
  show_course_datail0701: "0701Web-显示课程详情页",
  current_project_completed: '当前项目已结训',
  about_to_quit: '已到达培训项目结束时间，即将退出学习',
  countdown: '确定（{countNum}s）',
  get_exam_fail: '网络异常，获取考试资源失败',
  not_allow_quit: '考试中途不允许退出',
  exam_detail: '考试详情',
  select_location: '请先选择地理位置',
  custom_address: '自定义地址',
  add_location: "添加地理位置",
  effective_range: "有效范围",
  metre: '米',
  search: '搜索',
  system_error: '系统错误，请稍后再试',
  Live_not_started: '直播未开始，请稍后再试',
  spread: '展开',
  pack_up: '收起',
  Login_recovery: '登录态恢复',
  browser_version_low: '抱歉，您的浏览器版本过低可能影响e祺学网页版部分功能的使用。请升级到IE{version}及以上的浏览器或使用chrome浏览器打开e祺学网页版。',
  click_pic0104: '0104Web-点击头像',
  check_wallet0102: "0102Web-查看钱包",
  my_setting0106: '0106Web-我的设置',
  quit_login0107: '0107Web-退出登录',
  my_reimbursement: '我的报销',
  my_class_audit: '我的开班审核',
  wallet: '钱包',
  check_mes0103:'0103Web-查看消息',
  news:'消息',
  enter_search_keywords:'请输入搜索关键字/直播ID/短视频ID',
  loading:'加载中...',
  not_support_upload: '文件中有不支持上传的类型，请重新选择',
  upload_attachment: "上传附件",
  please_enter:"请输入",
  multiple_choice_qus: '多选题',
  single_choice_qus: '单选题',
  judgment_qus: '判断题',
  subjective_qus: '主观题',
  photographs: '图片题',
  completion: '填空题',
  matching: '连线题',
  attachment: '附件题',
  customs_clearance_task:'通关任务',
  sparring_robot:'陪练机器人',
  learn:"学习",
  share:"分享",
  make_comments:'对{typeName}「{name}」进行了评分',
  collect:"收藏",
  watch:"观看",
  host:"主持",
  send_gift:"赠礼了",
  completion_graduation:"完成结业",
  breakthrough_complete:'闯关完成',
  participate_in:'参与',
  read:'阅读',
  achieve_score:'，成绩{score}分',
  take_part_in:'参加',
  no_corporate_identity:'抱歉，你没有企业身份，无法使用e祺学网页版',
  no_homepage:'抱歉，你没有可见的首页，无法使用e祺学网页版',
  reset_password:'重设密码',
  access_time:'获得时间：',
  my_certificate:'我的证书',
  no_certificate:'还没有证书哦',
  custom_theme:'自定义专题',
  course_topics:'课程专题',
  no_permission_learn:'你没有权限学习该资源',
  points_acquisition_details:'积分获取明细',
  date:'YYYY年MM月',
  total_points:'总积分',
  points_rules:'积分规则',
  check_exam: '0404Web-查看考试',
  examination_time:'考试时间：',
  min_score:'及格分{minScore}分',
  total_score_detail:'满分{totalScore}分',
  question_num:'题目数{questionNum}题',
  learnTime_num: '观看/收听时长至少{learnTime}分钟已学',
  learnTime_zero: '点击即算已学',
  show_exam_list:'0403Web-显示我的考试列表',
  resource_center:'资源中心',
  edit:'编辑',
  edit_avatar:'编辑头像',
  avatar:'头像',
  upload_files_failed:'上传失败',
  upload_files_success:'上传成功',
  upload_again:'重新上传',
  preview_head_image:'头像预览',
  current_identity:'当前身份',
  switch:'切换',
  learn_time:'学习时长',
  learn_num:'学习次数',
  learn_course:'已学课程',
  files_size_limit_tip:'图片需要小于2M,请控制图片大小',
  support_type_img:'图片只支持JPG和PNG格式，请确保上传图片格式正确。',
  certificate:'证书',
  passwoed_not_empty:'旧密码、密码和确认密码不能为空！',
  old_password:"旧密码",
  enter_old_password:"请输入旧密码",
  pwd_format_error:"密码格式错误",
  new_password:"新密码",
  enter_pwd_rules:"请输入至少8位，并且包含英文和数字",
  confirm_pwd_error:"密码不一致",
  confirm_pwd:"确认密码",
  enter_pwd_again:"请再次输入密码",
  reset_pwd_success:"恭喜，重设密码成功！",
  go_back_home:"返回首页",
  sevice_error:'服务器错误！',
  client_error:'客户端错误！',
  login_again_please:'为了您的账户安全，请重新登录',
  account_out_time:'您的账号已超时，请重新登录。',
  zhiniao_portal:'e祺学平台',
  zhiniao_web_page:'e祺学网页版',
  quit:'退出',
  download:'下载',
  imprint:'打印',
  submit:'提交',
  nothing:'无',
  comment_click:'评论',
  updated_btn:'刷新',
  not_yet_course:'还没有课程',
  post_count:'{postCount}个帖子',
  give_score:"评分",
  no_data_yet:'暂无内容',
  which_level:'第{num}关',
  person_num:"{num}人",
  emojiImg:'表情',
  step_learn:'阶段学习项目',
  living_replay:'直播回放',
  phone_num:'手机号需为11位数字',
  pwd_length:'密码长度不得超过16位',
  learn_typeName: '学习{typeName}「{name}」',
  share_typeName: '分享{typeName}「{name}」',
  commend_typeName: '对{typeName}「{name}」进行了评分',
  collect_typeName: '收藏{typeName}「{name}」',
  look_typeName: '观看{typeName}「{name}」',
  host_typeName: '主持{typeName}「{name}」',
  gift_typeName: '赠礼了{typeName}「{name}」',
  completed_typeName: '{typeName}「{name}」完成结业',
  chuangguan_typeName: '闯关完成{typeName}「{name}」',
  participate_typeName: '参与{typeName}「{name}」{score}',
  grades_score: '，成绩{score}分',
  read_typeName: '阅读{typeName}「{name}」',
  comment_typeName: '评论{typeName}「{name}」',
  participate_in_training: '参训{typeName}「{name}」{score}',
  result_durationStr:'{result}，时长{durationStr}',
  typeValue_trainClassName:'参加{typeValue}「{trainClassName}」',
  totalScoreStr:'{totalScoreStr}分',
  pic_i_extend:'图片{i}.{extend}',
  latest_release:'最新发布',
  registered:'已报名',
  quantity: '{quantity}个',

  face_to_face_teaching:'面授课',
  quantity: '{quantity}个',
  voice_playing:'语音直播中',
  voice_back_playing:'语音直播回放中',
  no_reviewed:'未审阅',
  myOrder:'我的订单',
  and_too:'以及',
  cloud_school_project:'云校培训项目详情页',
  cloud_school_project_list:'云校培训项目公开列表',
  case_study_questions:'案例分析题',
  acknowledge:'确认',
  submitted:'已提交',
  invoicing_info_submitted:'已提交开票信息',
  invoice_applied:'已申请开票',
  Invoiced:'已开票',
  audit_failed:'审核未通过',
  revoked:'已撤销',
  cancel_invoice_request:'确认撤销该发票申请吗？',
  submit_invoice_request:'确认提交该发票申请吗？',
  submit_application:'提交申请',
  modify_application:'修改申请',
  application_canceled:'撤销申请',
  lump_sum_colon:'总金额：',
  enter_email_address:'请输入邮箱地址',
  email_address_colon:'邮箱地址：',
  enter_mailing_address:'请输入邮寄地址',
  mailing_address_colon:'邮寄地址：',
  enter_connect_num:'请输入联系电话',
  connect_num_colon:'联系电话：',
  electronic_Invoice:'电子发票',
  paper_Invoice:'纸质发票',
  billing_method:'开票方式：',
  enter_bank_account:'请输入银行帐号',
  bank_account_num:'银行帐号：',
  enter_opening_bank:'请输入开户银行',
  opening_bank:'开户银行：',
  enter_registered_number:'请输入注册电话',
  registered_number:'注册电话：',
  enter_registered_address:'请输入注册地址',
  registered_address:'注册地址：',
  enter_tax_number:'请输入公司税号',
  tax_number:'公司税号：',
  enter_company_title:'请输入公司名称',
  company_title:'公司名称：',
  mpre_content:'更多内容：',
  business_unit:'企业单位',
  individuals_corporate_units:'个人/非企业单位',
  header_type:'抬头类型：',
  ordinary_invoice:'普通发票',
  value_added_tax:'增值税专用发票',
  invoice_type:'发票类型：',
  Invoice_Information:'发票信息',
  Apply_invoice:'申请开票',
  Apply_time:'申请时间：',
  company_title_empty:'公司名称不能为空',
  company_tax_num_empty:'公司税号不能为空',
  company_tax_limit:'公司税号仅限输入英文或者数字',
  registered_address_empty:'注册地址不能为空',
  registered_number_empty:'注册电话不能为空',
  opening_bank_empty:'开户银行不能为空',
  bank_account_empty:'银行账号不能为空',
  connect_num_empty:'联系电话不能为空',
  mailing_address_empty:'邮寄地址不能为空',
  amail_address_empty:'邮箱地址不能为空',
  enter_true_email:'请填写正确的邮箱地址',
  rate_speed:'倍速',
  unLockTime:'{unLockTime} 会解锁哦～',
  open_zhiniao:'请打开e祺学app完成作业',
  correct_answer:'正确答案',
  my_answers:'我的答案',
  after_start_exam:'开始考试后，{text}，否则系统将判定考试结束。',
  not_close_brower:'请勿关闭浏览器或离开考试界面',
  administrator_to_unblock:'已达到切屏最大次数，禁止再次进入考试，请联系管理员解封',
  keep_screen_max:'请始终保持考试窗口最大化，否则无法开始考试',
  warning:'警告',
  cut_screen_times:'本次考试过程中禁止切屏，达到{maxTimes}次后，将视为作弊，自动交卷',
  cut_screen_maxTimes:'您已离开界面{maxTimes}次！已自动交卷',
  cheating_times:'您已离开界面{maxTimes}次！再离开考试{remainderTimes}次，将被视为作弊，自动交卷',
  examing_limit_tips:'考试中，请勿关闭浏览器或离开考试界面！',
  purchased_course:'已购课程',
  study_card:'学习卡课程',
  my_training_project:'我的培训项目',
  resource_duration:'{resourceDuration}学时',
  regular:'正常',
  end_data:'到期日：{expireDate}',
  study_card_cover:'学习卡封面',
  terminated:'已停用',
  expired:'已过期',
  studyCard:'学习卡',
  zhiniao_cloud:'e祺学知识云',
  go_cloud_home:'登录企业无权限查看该知识空间，即将跳转知识云首页',
  refund_amount:'退款金额(元):',
  detail_useNum:'已使用{useNum}人',
  refund_num:'退款数量(人):',
  apply_refund:'申请退款',
  check_refund_detail:'已退款，查看退款详情',
  check_refund_record:'查看退款记录',
  apay_time_colon:'支付时间:',
  order_time:'下单时间:',
  order_num:'订单编号:',
  real_payment:'实付款：',
  no_coupons_available:'暂无优惠劵可用',
  pay_format:'付款方式:',
  coupons_colon:'优惠券:',
  student_colon:'学员：',
  student_info:'学员信息：',
  total_price:'总价：',
  transaction_complete:'交易完成',
  order_details:'订单详情',
  apply_refund_success:'退款申请成功',
  refund_price_zero:'退款金额不能为0',
  refund_num_zero:'退款数量不能为0',
  max_refund_num:'退款数量不能大于未使用数量',
  max_refund_price:'退款金额不能大于订单金额',
  all_refund:'全部退费',
  part_refund:'部分退费',
  refund_failed:'退费失败',
  apply_refund_fee:'申请退费',
  business_business_transfer:'公对公转账',
  WeChat_Pay:'微信支付',
  pay_by_AliPay:'支付宝支付',
  Cancelled:'已取消',
  Paid:'已支付',
  to_be_confirmed:'待确认',
  to_be_paid:'待支付',
  check_item:'查看项目',
  invoice_record:'开票记录',
  no_my_order:'还没有我的订单',
  Refund_after_sale:'退款售后',
  price_from_text:"{text}起",
  price_from:"起",
  period_Total:'{periodTotal}个学时',
  training_duration_colon:'培训学时:',
  no_my_training_item:'还没有我的培训项目',
  leran_precess:'学习进度',
  complete_duration_count:'完成{completedHours}/{requiredHours}学时',
  remainHours_duration_count:'剩余{remainHours}学时',
  buy_duration_count:'已购{remainHours}学时',
  register_now:'立即报名',
  Register_start_learning:'报名当前培训项目即可开始学习',
  training_project_no_start:'培训项目未开始!',
  export_learn_report:'导出学习报告',
  export_data_empty:'导出数据不能为空！',
  Check_is_blocked:'1.检查是否被拦截：浏览器右上角出现如图所示的提示',
  click_intercept_icon:'2.点击拦截图标，将选项修改为“允许显示”',
  refresh_the_webpage:'3.刷新网页，再次点击“充值”',
  complete_fee_tips:'如果你已完成{feeWay1}，请点击“已完成{feeWay2}”',
  sign_up:'报名',
  Recharge:'充值',
  opration_follow_steps:'如系统未打开系统充值页面，请按照如下步骤操作',
  company_feeWay:'已完成{feeWay}',
  click_on:'点击',
  cross_domain_image:'这是一张跨域图片',
  cross_regional_picture:'来个跨区的图片',
  Statistics_Time:'统计时间：',
  learned_availid_duration:'已完成有效学时：',
  Organization:'所属组织：',
  Position_type_work:'岗位(工种)：',
  Credentials:'证件：',
  mobile_number_colon:'手机号：',
  staff_code:'员工编号：',
  gender:'性别：',
  name_colon:'姓名：',
  basic_information:'基础信息',
  training_project_colon:'培训项目：',
  personal_learning_report:'培训项目个人学习报告',
  page_num:'页码: {index}/{arr}',
  data_from_colon:'数据出处：',
  catalog_list:'目录({resourcesCount})',
  learned_no_refund:'在线课程学习后将不再退费',
  refrash_duration:'学时升级',
  i_go_sign_up:'我要报名',
  refunding_tips:'正在退款中, 不能{headDateil}',
  pageFrom_project:'{pageFrom}培训项目',
  mine:'我的',
  project_study_report:'培训项目个人学习报告',
  Pre_school_verification:'学前验证实名认证',
  product_info:'商品信息',
  Specification:'规格',
  trading_status:'交易状态',
  refund_details:'退款详情',
  completed_time_colon:'完成时间：',
  sum_price:'总金额',
  payment_real:'实付款',
  RESOURCE_TYPE_team:'{RESOURCE_TYPE}(团体)',
  coursePeriod_duration:'{coursePeriod}学时',
  buyers_Num:'{buyersNum}人',
  study_information:'学员信息',
  order_information:'下单人信息',
  student_name_colon:'学员姓名:',
  phone_num_colon:'手机号码:',
  order_info:'订单信息',
  pay_time_colon:'付款时间:',
  no_available_coupons:'暂无可用优惠劵',
  refund_amount_colon:'退款金额:',
  refund_colon:'退款：',
  Public_public_payment:'公对公支付',
  Refund_under_review:'退款审核中',
  Payment_time_colon:'支付时间：',
  school_short_video:'学堂短视频',
  school_live:'学堂直播',
  pay_success_confirm:'你已经成功付款',
  pay_failed:'支付失败',
  WeChat_payment_limit:'请注意微信支付交易限额，若无法支付，可尝试使用支付宝支付。',
  means_transaction:'交易方式',
  pay_money:'{payMoney}元',
  transaction_amount:'交易金额',
  use_WeChat_scan:'请使用微信扫码支付',
  sevice_qus_connect:'如对e祺学购买服务存在疑问，请于法定工作日办公时间（9:00-12:00，13:30-18:00）致电：400-603-8258与客服MM联系',
  upgrade_immediately:'立即升级',
  Amounts_payable:'应付金额：',
  order_total_price:'订单总价：{text}',
  Payment_Information:'支付信息：',
  payment_method:'支付方式：',
  After_upgrade:'升级后：',
  pre_upgrade:'升级前：',
  select_upgraded_specification:'请选择升级的规格：',
  identity_number:'身份证号：',
  complete_student_information:'请完善学员信息',
  total_periodTotal:'共{periodTotal}个学时',
  enter_identity_numbe:'请输入正确身份证号',
  enter_stu_name:'请输入学生姓名',
  Certificate_being_generated:'证书生成中，请稍后查看',
  click_course_duration:'点击课件成功播放消耗学时',
  buy_duration_learn:'请购买学时继续学习',
  select_more_look:'集中观看时，请选择【多人观看】，在场用户便可计入学习数据，获取学习激励！',
  sign_QR_code:'签到二维码_{roomId}.png',
  QR_code_no_exist:'二维码地址不存在！',
  use_app_login:'在场用户登陆e祺学APP，扫码签到，签到后不要离开哦，观看结束时，还需继续完成签出！',
  scon_code_login:'扫码签到',
  after_sign_up:'签到后，务必记得完成签出！',
  scan_left_code:'e祺学APP - 左上角扫一扫',
  watching_intensively:'集中观看时，扫码签到、签出可获得积分，抽取豪华大奖!',
  enter_live_sign:'进入直播间继续签到',
  scan_look:'扫码观看',
  sign_QR_code_room:'签到二维码_{roomId}',
  et_up_centralized:'首先，请先设置集中观看的位置，在场用户在该位置范围内签到和签出',
  lower_meters:'米(≤1000米)',
  zhiniao_meeting:'e祺学会议',
  cloud_school_end:'当前云教室已结束',
  hours_ago:'{h}小时',
  hours_min_detail:'{h}小时{m}分钟',
  few_minutes:'{m}分钟',
  use_other_browers:'请使用其他浏览器打开或复制链接到其他浏览器打开，谢谢',
  meeting_num:'会议号：',
  host_room_colon:'主持人：',
  phone_meeting:'手机参会',
  enter_meeting:'加入会议',
  scan_code_enter:'手机扫码，加入云教室',
  Arousing_client:'正在唤起客户端…',
  Arousing_failed:'如未安装或者唤起失败，请点击',
  download_client:'下载客户端',
  admin_set_replay:'债权人会议已结束，如需观看，请联系管理人设置回放！',
  live_end_replay:'直播已结束，如需观看，请联系管理人设置回放！',
  check_in_ahead_time:'前, 请先提前完成签到！',
  Remember_complete_checkout:'后, 务必记得完成签出！',
  panelText_QR_code:'{panelText}二维码_{roomId}',
  QR_code_loading:'二维码加载中...',
  Draw_luxury_prizes:'集中观看时，扫码签到、签出可获得积分，抽取豪华大奖!',
  scan_panelText:'扫码{panelText}',
  currently_playing:'当前正在播放的就是当前视频',
  next_video:'下一片段',
  add_look_data:'如部门集中观看，可点击右侧开启集中观看二维码计入部门观看数据。',
  looking_sign_every_time:'观看中，可随时打开签到码让未签到人员补签到',
  learnd_need_sign:'观看结束后，需打开签出二维码，在场用户完成签出后方可计入学习数据',

  Password_live_room:"口令直播间",
  enter_live_room:"进入直播间",
  apply_live:"直播申请",
  enter_go_live:"点击这里可以申请直播哦～",
  enter_Password_live:"进入口令直播",
  people_num_icon:"人数icon",
  Service_Agreement:'服务协议' ,
  Zhiniao_Privacy_Polic: 'e祺学隐私权政策',
  Ping_An_Software_Agreement:'e祺学软件许可及服务协议',
  click_btn_verify:'点击按钮进行验证',
  study_card_paid: '已购学习卡',

  question_bank: '题库',
  job_develop_path: '岗位发展路径',
  total_amount: '总价：￥{totalAmount}',
  to_start: '待开始',
  answer_questions: '请根据以上材料回答问题：',
  word: '口令',
  knowledge_cloud: '知识云',
}
